import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../index';

import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  ADD_IMPROVEMENT_CLICK: '8313',
  PROPERTY_CARD_CLICK_ZRAM: '8314',
  CHANGE_AD_PRODUCT: '5548',
} as const;

// https://dataportal.zillowgroup.net/event-registry/8313
export const emitAddImprovementClickEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.ADD_IMPROVEMENT_CLICK,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'add_improvement_click',
    },
    semantic: {
      semantic_event_nm: 'click_add_improvement',
      topic_tag_txt: ['zram_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8314
export const emitPropertyCardClickZRAMEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.PROPERTY_CARD_CLICK_ZRAM,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'property_card_click',
    },
    semantic: {
      semantic_event_nm: 'click_properties_zram',
      topic_tag_txt: ['zram_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5548
export const emitChangeAdProductEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CHANGE_AD_PRODUCT,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zram_property_summary',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'change_ad_product',
    },
    semantic: {
      semantic_event_nm: 'change_ad_product_button',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });
